const data = [
  {
    id: 1,
    sortOrder: 1,
    title: 'Landing',
    type: 'landing',
  },
  {
    id: 2,
    sortOrder: 2,
    title: 'What is this?',
    type: 'description',
    text: 'We found the most tweeted emojis during the NBA playoffs\' ' +
      'biggest moments. Here are our favorites.',
  },
  {
    id: 3,
    sortOrder: 3,
    title: 'Don\'t Step to the MVP',
    type: 'gif',
    gameTitle: 'HOU V GSW: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/rockets_warriors-loveeyes.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/rockets_warriors-loveeyes.gif',
      width: 480,
    },
    emojis: [
      {
        character: '😍',
        count: 200,
      },
    ],
  },
  {
    id: 4,
    sortOrder: 4,
    title: 'CP3\'s Bad News',
    type: 'gif',
    gameTitle: 'POR V LAC: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/blazers-clippers-crab-hand.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/blazers-clippers-crab-hand.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🦀',
        count: 102,
      },
    ],
  },
  {
    id: 5,
    sortOrder: 5,
    title: 'Never Stop Dancing',
    type: 'gif',
    gameTitle: 'DAL V OKC: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/NeverStopDancing.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/NeverStopDancing.gif',
      width: 480,
    },
    emojis: [
      {
        character: '😤',
        count: 383,
      },
    ],
  },
  {
    id: 6,
    sortOrder: 6,
    title: 'Locked Down',
    type: 'gif',
    gameTitle: 'MEM V SAS: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/kawhi-locked.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/kawhi-locked.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🔒',
        count: 62,
      },
    ],
  },
  {
    id: 7,
    sortOrder: 7,
    title: 'LeBron Quake/Hammer',
    type: 'gif',
    gameTitle: 'DET V CLE: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/LeBronQuakeHammer.jpg',
      width: 480,
    },
    image: {
      height: 576,
      url: 'assets/images/LeBronQuakeHammer.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🔥',
        count: 212,
      },
    ],
  },
  {
    id: 8,
    sortOrder: 8,
    title: 'The Flop',
    type: 'gif',
    gameTitle: 'BOS V ATL: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/Marcus-Smart-wild-flop.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/Marcus-Smart-wild-flop.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🍀',
        count: 293,
      },
    ],
  },
  {
    id: 9,
    sortOrder: 9,
    title: 'D-Wade Hushes Hater',
    type: 'gif',
    gameTitle: 'CHA V MIA: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/purpleface.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/purpleface.gif',
      width: 480,
    },
    emojis: [
      {
        character: '😈',
        count: 146,
      },
    ],
  },
  {
    id: 10,
    sortOrder: 10,
    title: 'Cheers from the 6ix',
    type: 'gif',
    gameTitle: 'IND V TOR: RD 1',
    coverImage: {
      height: 480,
      url: 'assets/images/drake-clap.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/drake-clap.gif',
      width: 480,
    },
    emojis: [
      {
        character: '👏',
        count: 120,
      },
    ],
  },
  {
    id: 11,
    sortOrder: 11,
    title: 'I\'m Back!',
    type: 'gif',
    gameTitle: 'POR V GSW: RD 2',
    coverImage: {
      height: 480,
      url: 'assets/images/imback.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/imback.gif',
      width: 480,
    },
    emojis: [
      {
        character: '👀',
        count: 847,
      },
    ],
  },
  {
    id: 12,
    sortOrder: 12,
    title: 'The Controversy',
    type: 'gif',
    gameTitle: 'OKC V SAS: RD 2',
    coverImage: {
      height: 480,
      url: 'assets/images/controversey.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/controversey.gif',
      width: 480,
    },
    emojis: [
      {
        character: '😳',
        count: 3702,
      },
    ],
  },
  {
    id: 13,
    sortOrder: 13,
    title: 'Snoozin\'',
    type: 'gif',
    gameTitle: 'ATL V CLE: RD 2',
    coverImage: {
      height: 480,
      url: 'assets/images/Snoozin.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/Snoozin.gif',
      width: 480,
    },
    emojis: [
      {
        character: '👌',
        count: 1378,
      },
    ],
  },
  {
    id: 14,
    sortOrder: 14,
    title: 'The Dragon\'s Tooth',
    type: 'gif',
    gameTitle: 'MIA V TOR: RD 2',
    coverImage: {
      height: 480,
      url: 'assets/images/dragictooth.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/dragictooth.gif',
      width: 480,
    },
    emojis: [
      {
        character: '👊',
        count: 264,
      },
    ],
  },
  {
    id: 15,
    sortOrder: 15,
    title: 'Westbrook\'s Shuffle',
    type: 'gif',
    gameTitle: 'OKC V GSW: WCF',
    coverImage: {
      height: 480,
      url: 'assets/images/WestbrookShuffle.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/WestbrookShuffle.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🐸',
        count: 524,
      },
      {
        character: '☕',
        count: 521,
      },
    ],
  },
  {
    id: 16,
    sortOrder: 16,
    title: 'Bruised Jewels',
    type: 'gif',
    gameTitle: 'OKC V GSW: WCF',
    date: 'May 7, 2016 8:45PM EST',
    coverImage: {
      height: 480,
      url: 'assets/images/draymondkicksadams.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/draymondkicksadams.gif',
      width: 480,
    },
    emojis: [
      {
        character: '✨',
        count: 1409,
      },
    ],
  },
  {
    id: 17,
    sortOrder: 17,
    title: 'Cavs\' Friendly Fire',
    type: 'gif',
    gameTitle: 'TOR V CLE: ECF ',
    coverImage: {
      height: 480,
      url: 'assets/images/CavsFriendlyFire.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/CavsFriendlyFire.gif',
      width: 480,
    },
    emojis: [
      {
        character: '💀',
        count: 449,
      },
    ],
  },
  {
    id: 18,
    sortOrder: 18,
    title: 'Curry\'s Dagger',
    type: 'gif',
    gameTitle: 'OKC V GSW: WCF',
    coverImage: {
      height: 480,
      url: 'assets/images/currydagger.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/currydagger.gif',
      width: 480,
    },
    emojis: [
      {
        character: '💯',
        count: 408,
      },
    ],
  },
  {
    id: 19,
    sortOrder: 19,
    title: 'Clipboard Smash',
    type: 'gif',
    gameTitle: 'CLE V GSW: FINALS',
    coverImage: {
      height: 480,
      url: 'assets/images/broken-clipboard.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/broken-clipboard.gif',
      width: 480,
    },
    emojis: [
      {
        character: '😭',
        count: 3380,
      },
      {
        character: '💪',
        count: 997,
      },
    ],
  },
  {
    id: 20,
    sortOrder: 20,
    title: 'The Block',
    type: 'gif',
    gameTitle: 'CLE V GSW: FINALS',
    date: 'May 7, 2016 8:45PM EST',
    coverImage: {
      height: 480,
      url: 'assets/images/lebronblockiggy.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/lebronblockiggy.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🙌',
        count: 368,
      },
    ],
  },
  {
    id: 21,
    sortOrder: 21,
    title: 'Champions',
    type: 'gif',
    gameTitle: 'CLE V GSW: FINALS',
    date: 'May 7, 2016 8:45PM EST',
    coverImage: {
      height: 480,
      url: 'assets/images/champion.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/champion.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🏆',
        count: 612,
      },
    ],
  },
  {
    id: 22,
    sortOrder: 22,
    title: 'Mouthguard',
    type: 'gif',
    gameTitle: 'CLE V GSW: FINALS',
    coverImage: {
      height: 480,
      url: 'assets/images/mouthguard.jpg',
      width: 480,
    },
    image: {
      height: 480,
      url: 'assets/images/mouthguard.gif',
      width: 480,
    },
    emojis: [
      {
        character: '🐝',
        count: 422,
      },
    ],
  },
  {
    id: 23,
    sortOrder: 23,
    title: 'Credits',
    type: 'credits',
    text: 'Produced by<br/>Kate Strassman<br/>& Mike Fey',
  },
];

export default data;



/** WEBPACK FOOTER **
 ** ./assets/js/src/data/data.js
 **/